const TOKEN_PARAM_NAME = 'csrf3-token';

// Login and Signup endpoints used to be included here, but they have been deprecated.
// See ticket on Jira here: https://coursera.atlassian.net/browse/GR-17571
const ENDPOINT = {
  logout: '/api/logoutSsr/v1',
} as const;

const exported = {
  /**
   * Generates the action URL for the specified authentication mode and CSRF token.
   *
   * @todo Since this utility is currently only used for logout, consider removing the `authMode` parameter.
   * The CSRF token fetch should also be moved from the caller into the utility itself (if it's still needed).
   *
   * @param {keyof typeof ENDPOINT} authMode - The authentication mode, currently only 'logout'.
   * @param {string} csrfToken - The CSRF token for the request.
   * @returns {string} The formatted action URL.
   */
  getActionUrl(authMode: keyof typeof ENDPOINT, csrfToken: string) {
    const endpoint = ENDPOINT[authMode];
    return `${endpoint}?${TOKEN_PARAM_NAME}=${csrfToken}`;
  },
};

export default exported;

export const { getActionUrl } = exported;
